<script setup>
import moment from "moment";
import {ref, watch, computed, onMounted, reactive} from 'vue'

import TextInput from "@/components/common/input/TextInput";
import Validation from "@/classes/global/Validation";

const displayedDate = ref('');
const dateInput = ref('');
const selectionMade = ref(false);

const emits = defineEmits(['update:modelValue', 'update:validationFail',
  'input', 'selected-date', 'clear']);

const props = defineProps({

  modelValue: null,

  validationFail: {type: Object, default: new Validation},
  validationText: {type: Array, default: ['Required', 'Incorrect Format']},
  disable: false,
  label: String,
  labelWidth: Number,
  width: { type: Number, default: 120 },
  labelTop: { type: Boolean, default: false },
  requiredField: { type: Boolean, default: false },
  highlightRequiredBackground: { type: Boolean, default: false },
})

onMounted(() => {
  if (props.modelValue) {
    displayedDate.value = props.modelValue;
  }
})

watch(() => props.modelValue, (newValue, oldValue) => {
  displayedDate.value = props.modelValue;
  dateInput.value = '';
  selectionMade.value =  false;
})

// Start of methods
function numberOnlyCheck(e) {

  if (!(/[\/0-9]/.test(e.key))) {
    e.preventDefault();

  } else if (e.key === '/' && dateInput.value.charAt(dateInput.length - 1) === '/') {
    e.preventDefault();

  } else {
    return true;
  }

};

function prepareInputData(e) {

  emits('update:validationFail', new Validation());
  emits('input');

  // Handle delete key
  if (!e.data) {
    return
  }

  if (dateInput.value.length === 2 || dateInput.value.length === 5) {
    dateInput.value += "/"
  }

};

function setFormat(userDateInput) {

  if (userDateInput !== "") {
    let checkDate = moment(userDateInput, ['DD-MM-YYYY']).format('DD-MMM-YY');

    if (checkDate !== 'Invalid date') {

      displayedDate.value = checkDate;
      emits('update:modelValue', checkDate);
      emits('selected-date', checkDate);
      selectionMade.value = true;

    } else {
      emits('update:validationFail', new Validation(1, true));

    }

  }

};

function handleFocusAndEnterKey(userValue) {

  emits('update:validationFail', new Validation());

  if (userValue.length === 10 && selectionMade.value === false) {
    this.setFormat(dateInput.value);

  } else if (userValue !== '' && userValue.length !== 10) {
    emits('update:validationFail', new Validation(1, true));
  }

};

</script>

<template>
  <div id="Vue-3-component-date-input" class="date-input-wrapper">
    <div style="position: relative;">
      <text-input
          @keydown.enter="handleFocusAndEnterKey(dateInput)"
          @keypress="numberOnlyCheck"
          @input="prepareInputData"
          :highlightRequiredBackground="props.highlightRequiredBackground"
          :max-length="10"
          :label="label"
          :label-width="labelWidth"
          :label-top="labelTop"
          :requiredField="requiredField"
          :width="props.width - 25"
          @focusout="handleFocusAndEnterKey(dateInput)"
          placeholder="eg: dd/mm/yy"
          :clearable="false"
          :validation-text="validationText"
          :validation-fail="validationFail"
          :disable="disable"
          v-if="!displayedDate"
          v-model="dateInput">
      </text-input>
    </div>
    <div style="position: relative;">
      <text-input
          data-cy="txtConvertedDate"
          v-if="displayedDate"
          :label="label"
          :label-width="labelWidth"
          :label-top="labelTop"
          :requiredField="requiredField"
          :width="props.width - 25"
          :clearable="true"
          :readonly="true"
          @cleared="$emit('clear')"
          @update:modelValue="$emit('update:modelValue', '')"
          v-model="displayedDate">
      </text-input>
    </div>
    <div class="date-input-slot">
      <slot></slot>
    </div>

  </div>
</template>

<style scoped>

.date-input-wrapper {
  display: flex;
}

.date-input-slot {
  margin-left: 15px;
  margin-top: -3px;
}
</style>
